import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-project-summary-dw",
  templateUrl: "./project-summary-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSummaryDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.PROJECT_SUMMARY_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
